import { CardNetwork, FundingSource } from '@melio/platform-api';

export function getFundingSourceLabel(fundingSource?: FundingSource) {
  if (!fundingSource) {
    return 'No funding source selected';
  }
  if (fundingSource.type == 'bank-account') {
    return 'Bank Account';
  }
  if (fundingSource.details.type == 'credit') {
    return 'Credit Card';
  }
  return 'Debit Card';
}

export function getFundingSourceDisplayName(fundingSource?: FundingSource) {
  if (!fundingSource) {
    return 'No funding source selected';
  }

  if (fundingSource.type == 'bank-account') {
    const { details: bankAccount } = fundingSource;
    const accountType = bankAccount.accountType === 'checking' ? 'Checking Account' : 'Saving Account';
    return [accountType, '...', bankAccount.accountNumber.slice(-4)].join(' ');
  }

  const { details: card } = fundingSource;

  const networks: Record<CardNetwork, string> = {
    visa: 'Visa',
    mastercard: 'Mastercard',
    amex: 'American Express',
    discover: 'Discover',
    other: card.type === 'credit' ? 'Credit Card' : 'Debit Card',
  };

  return [networks[card.network], '...', card.lastFourDigits].join(' ');
}
